import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Box, Collapse, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'

import { CustomOrderAdminDto, CustomOrderClientDto, ReceiptDto } from 'service-api/src/types/api'

export interface DepositPoliciesDropdownProps {
  order: CustomOrderAdminDto | CustomOrderClientDto
  receipt: ReceiptDto
}

export const DepositPoliciesDropdown = ({ order, receipt }: DepositPoliciesDropdownProps) => {
  const { palette } = useTheme()
  const [open, setOpen] = useState(false)
  const policies = receipt.refundPolicyV2 || []

  return (
    <Box sx={{ mt: 1 }}>
      <Stack direction="row" alignItems="center" onClick={() => setOpen((prev) => !prev)} sx={{ cursor: 'pointer' }}>
        <Typography variant="body1bold" sx={{ color: palette.text.secondary }}>
          Deposit Policies
        </Typography>
        <ArrowDropDownIcon
          sx={{
            color: palette.text.secondary,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        />
      </Stack>
      <Collapse in={open}>
        <Box sx={{ mt: 1, pl: 1 }}>
          <table style={{ width: '100%', tableLayout: 'auto', borderCollapse: 'separate', borderSpacing: '0 4px' }}>
            <tbody>
              {policies.map((entry, idx) => (
                <tr key={idx}>
                  <td>
                    <Typography variant="body2">{entry.depositDates || ''}</Typography>
                  </td>
                  <td>
                    <Typography variant="body2">{entry.depositPolicy || ''}</Typography>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <Typography variant="body2">{entry.depositAmount || ''}</Typography>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Collapse>
    </Box>
  )
}
